module.exports = "pegasus_template/assets/social_share_library_block.png";